export enum ModelHoldingCategory {
    Equity = 'Equity',
    FixedIncome = 'FixedIncome',
}
